import { Box, Button, TextField, Typography, useTheme } from '@mui/material';
import { useState } from 'react';

import { PortalTheme, SitesMenuIcon } from '@frontend-libs/portal';

import { siteUnitClient } from '@portal-clients/site-unit';

import { useSubmit } from '@frontend/hooks';
import { tApp } from '@frontend/locales';

export interface SiteUnitAccessProps {
  handleSuccess: () => void;
  hasExistingAccess?: boolean;
}

export const SiteUnitAccess = ({
  handleSuccess,
  hasExistingAccess = false,
}: SiteUnitAccessProps) => {
  const theme = useTheme<PortalTheme>();
  const [code, setCode] = useState('');
  const [error, setError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  const { submit } = useSubmit({
    onSubmit: async () => {
      setIsLoading(true);
      await siteUnitClient.unlock(code.trim());
      handleSuccess();
    },
    onError() {
      setError(true);
      setIsLoading(false);
    },
  });

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        textAlign: 'center',
      }}
    >
      <SitesMenuIcon
        width={120}
        height={120}
        filled={true}
        stroke={theme.palette.grey[300]}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="h6" fontWeight="bold">
          {hasExistingAccess
            ? tApp.siteUnits.addAccess.title()
            : tApp.siteUnits.empty.title()}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: theme.palette.text.secondary, maxWidth: 280 }}
        >
          {tApp.siteUnits.empty.subtitle()}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
          width: '100%',
        }}
      >
        <TextField
          fullWidth
          label={tApp.siteUnits.empty.inputLabel()}
          value={code}
          onChange={(e) => {
            setCode(e.target.value);
            setError(false);
          }}
          variant="outlined"
          size="medium"
        />
        <Button
          fullWidth
          size="large"
          variant="contained"
          disabled={!code.trim() || isLoading}
          onClick={submit}
        >
          {tApp.siteUnits.empty.button()}
        </Button>
        {error && (
          <Typography variant="body2" color="error">
            {tApp.siteUnits.empty.invalidCode()}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
